import React from 'react';
import { useCart } from '../context/CartContext';
import './CartButton.css';

function CartButton() {
  const { getCartCount, setIsCartOpen } = useCart();
  const count = getCartCount();

  return (
    <button 
      className="cart-button-float"
      onClick={() => setIsCartOpen(true)}
      aria-label="Shopping cart"
    >
      <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2"
      >
        <circle cx="9" cy="21" r="1"/>
        <circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
      </svg>
      {count > 0 && <span className="cart-badge">{count}</span>}
    </button>
  );
}

export default CartButton;